import axios from "axios";
import React from "react";
import { BASEURL } from "../../constant/constant";
import { ValidateName } from "../../helpers/validators";
import { alertService, AlertType } from "../../utils/alert.service";
import AcInputText from "../AcInputText/AcInputText";
import ButtonTop from "../AcInputText/ButtonTop";
import SearchBar from "../AcInputText/SearchBar";
import { AddCategory } from "../Popup/Popup";

const MeasureTop = ({
  setSize,
  toggleAddCatPopup,
  isOpen,
  mInch,
  setMInch,
  mesList,
  errors,
  setErrors,
  mesData,
  handleChangeSearch,
  searchInput,
}) => {
  const addMeasurement = async () => {
    const auth_token = sessionStorage.getItem("auth_token");

    const item = {
      name: mInch,
    };
    try {
      const response = await axios({
        url: BASEURL + "product/measurement/create",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: auth_token,
        },
        data: item,
      });
      if (response.status === 200) {
        alertService.alert({
          type: AlertType.Success,
          message: response.data.message,
        });
        toggleAddCatPopup();
        setMInch("");
        mesList();
      }
    } catch (error) {
      if (error.response.status === 404) {
        alertService.alert({
          type: AlertType.Error,
          message: error.response.data.map((item) => item.message).join("\n"),
        });
      } else if (error.response.status === 409) {
        alertService.alert({
          type: AlertType.Error,
          message: error.response.data.map((item) => item.message).join("\n"),
        });
      } else {
        alertService.alert({
          type: AlertType.Error,
          message: error.response.data.map((item) => item.message).join("\n"),
        });
      }
    }
  };

  const validator = () => {
    let newErrors = {};
    let isValid = true;
    const statusName = ValidateName(mInch);

    if (statusName) {
      newErrors.mInch = statusName === 1 ? "Measurement is Required" : "";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const submitMeasureHandler = (e) => {
    e.preventDefault();
    if (validator()) {
      addMeasurement();
    }
  };

  return (
    <div className="content-top">
      <div className="content-top-left">
        <span className="content-top-left-title">MEASUREMENT LIST</span>
        <span className="content-top-left-desc">
          All Measurement Detail Listed Here Also You Can Update or Delete
        </span>
        {mesData?.list?.length > 0 ? (
          <span className="cat-content-top-left-dropdown">
            Show&nbsp;
            <select
              id="number-dd"
              name="number"
              onChange={(e) => setSize(e.target.value)}
            >
              {[10, 25, 50, 75, 100, 125, 150, 175, 200].map((item) => (
                <option value={item}>{item}</option>
              ))}
            </select>
            &nbsp; Entries
          </span>
        ) : (
          ""
        )}
      </div>
      <div className="content-top-right">
        <ButtonTop onClick={toggleAddCatPopup} name={"Add Measurement"} />
        <SearchBar onChange={handleChangeSearch} value={searchInput} />
      </div>
      {isOpen && (
        <AddCategory
          content={
            <form>
              <div className="cat-first">
                <span className="cat-title">MEASUREMENT DETAILS</span>
                <span className="cat-desc">All field are required</span>
              </div>
              <div className="cat-second">
                <span className="cat-second-title">
                  Personal Details
                  <div className="cat-second-hr">
                    <hr />
                  </div>
                </span>
                <div className="cat-second-firstRow">
                  <AcInputText
                    label="Measurement"
                    type="text"
                    placeholder="Measurement"
                    value={mInch.inch}
                    onChange={(e) => setMInch(e.target.value)}
                    error={errors?.mInch}
                  />
                </div>
              </div>
              <div className="cat-second-bottam-btn">
                <button
                  onClick={submitMeasureHandler}
                  className="cat-second-bottam-btn-sub"
                >
                  Submit
                </button>
                <button
                  className="cat-second-bottam-btn-can"
                  onClick={toggleAddCatPopup}
                >
                  Cancel
                </button>
              </div>
            </form>
          }
        />
      )}
    </div>
  );
};

export default MeasureTop;
